// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22s6U","colBig":"styles_colBig__znK3D","colSmall":"styles_colSmall__3FVQy"};